import { render, staticRenderFns } from "./CustomNavLink.vue?vue&type=template&id=b98cc3a4&scoped=true"
import script from "./CustomNavLink.vue?vue&type=script&lang=js"
export * from "./CustomNavLink.vue?vue&type=script&lang=js"
import style0 from "./CustomNavLink.vue?vue&type=style&index=0&id=b98cc3a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b98cc3a4",
  null
  
)

export default component.exports